import get from 'lodash/get';
import forEach from 'lodash/forEach';
import toArray from 'lodash/toArray';

import { caseLogicMsg } from '../validationMessages';
import {
  nonAiActionTypes,
  nonAiCheckTypes,
  nonAiEffectTypes,
  aiActionTypes,
  aiCheckTypes,
  aiEffectTypes
} from '~lib/common/utils/disabledNodeTypes';

function validateDisabledNodes(caseConf) {
  const nodes = toArray(get(caseConf, 'caseLogicDescription.nodes'));

  const isAiEnabled = caseConf.dialogue.aiEnabled;
  const warnings = [];

  nodes.filter(node => node.name === 'Action').forEach((node) => {
    const action = get(node, 'data.action');
    if (action) {
      if (isAiEnabled && nonAiActionTypes.includes(action.type)) {
        warnings.push(caseLogicMsg('Legacy dialogue nodes not compatible with AI dialogue', node.id));
      }
      if (!isAiEnabled && aiActionTypes.includes(action.type)) {
        warnings.push(caseLogicMsg('AI dialogue nodes not compatible with legacy dialogue', node.id));
      }
    }
  });

  // Effect nodes
  nodes.filter(node => node.name === 'Effect').forEach((node) => {
    const effect = get(node, 'data.effect');
    if (effect) {
      if (isAiEnabled && nonAiEffectTypes.includes(effect.type)) {
        warnings.push(caseLogicMsg('Legacy dialogue nodes not compatible with AI dialogue', node.id));
      }
      if (!isAiEnabled && aiEffectTypes.includes(effect.type)) {
        warnings.push(caseLogicMsg('AI dialogue nodes not compatible with legacy dialogue', node.id));
      }
    }
  });


  // Check nodes
  nodes.filter(node => node.name === 'Check').forEach((node) => {
    forEach(node.data, (check) => {
      if (check) {
        if (isAiEnabled && nonAiCheckTypes.includes(check.type)) {
          warnings.push(caseLogicMsg('Legacy dialogue nodes not compatible with AI dialogue', node.id));
        }
        if (!isAiEnabled && aiCheckTypes.includes(check.type)) {
          warnings.push(caseLogicMsg('AI dialogue nodes not compatible with legacy dialogue', node.id));
        }
      }
    });
  });

  return {
    errors: [],
    warnings,
  };

}

export default validateDisabledNodes;